import { createReducer, on } from '@ngrx/store';

import { AdminAccount, GetAccountResponse } from '../../proto/consulate';
import { AccountActions } from './action-types';
import { OxioPermissions } from '../../proto/consulate/accounts/interfaces';

export interface AccountState {
  adminAccount: AdminAccount & GetAccountResponse;
  isOxioAdmin: boolean;
  isLoading?: boolean;
  storedPermissions?: { [key: string]: boolean };
  permissions?: OxioPermissions;
}

const initialState: AccountState = {
  adminAccount: undefined,
  isOxioAdmin: false,
  isLoading: true,
};

export const accountReducer = createReducer(
  initialState,
  on(
    AccountActions.loginSuccess,
    AccountActions.invitationSuccess,
    (_, action) => {
      return {
        adminAccount: action.adminAccount,
        isOxioAdmin: action.isOxioAdmin,
        isLoading: false,
        permissions: action.permissions,
      };
    }
  ),

  on(AccountActions.getAccountSuccess, (state, action) => {
    return {
      ...state,
      adminAccount: action.adminAccount,
      isOxioAdmin: action.isOxioAdmin,
      isLoading: false,
      permissions: action.permissions,
    };
  }),

  on(AccountActions.setOXIOAdmin, (state, action) => {
    return {
      ...state,
      isOxioAdmin: action.isOxioAdmin,
    };
  }),

  on(AccountActions.login, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),

  on(AccountActions.purge, () => {
    return {
      adminAccount: undefined,
      isLoading: false,
      isOxioAdmin: false,
      storedPermissions: undefined,
    };
  }),
  on(AccountActions.logout, () => {
    return {
      adminAccount: undefined,
      isLoading: false,
      isOxioAdmin: false,
      storedPermissions: undefined,
    };
  }),
  on(AccountActions.loginFailure, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(AccountActions.addStoredPermission, (state, action) => {
    const rule = { ...action };
    delete rule.type;

    return {
      ...state,
      storedPermissions: { ...state.storedPermissions, ...rule },
    };
  })
);
